import React from "react";
import ModalSideBar from "../../../../../components/ModalSideBar";
import { formatDateTimeBR } from "../../../../../helpers/format";
import { ICustoTriagem } from "../types/types";

// import { Container } from './styles';

interface Props {
  data?: ICustoTriagem;
  onClose: () => void;
  title: string;
}

const Info: React.FC<Props> = (props: Props) => {
  return (
    <ModalSideBar isOpen title={props.title} onClose={props.onClose}>
      <div className="w-full h-full">
        <div className="w-full grid grid-cols-2 gap-2 gap-y-6">
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              ID
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.id_custo_triagem !== undefined && props.data?.id_custo_triagem !== null
                ? String(props.data.id_custo_triagem)
                : "---"}
            </span>
          </div>
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">
              Tipo Veículo
            </span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.tipo_veiculo !== undefined && props.data?.tipo_veiculo !== null
                ? String(props.data.tipo_veiculo)
                : "---"}
            </span>
          </div>
        </div>
        <div className="w-full grid grid-cols-2 gap-2 gap-y-6 mt-4">
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">Tipo Carga</span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.tipo_carga !== undefined && props.data?.tipo_carga !== null
                ? String(props.data.tipo_carga)
                : "---"}
            </span>
          </div>

          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">Tipo Operação</span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.tipo_operacao !== undefined && props.data?.tipo_operacao !== null
                ? String(props.data.tipo_operacao)
                : "---"}
            </span>
          </div>
        </div>

        <div className="w-full grid grid-cols-2 gap-2 gap-y-6 mt-4">
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">Tempo Base (min)</span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.tempo_base_triagem !== undefined && props.data?.tempo_base_triagem !== null
                ? String(props.data.tempo_base_triagem)
                : "---"}
            </span>
          </div>

          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">Custo Base</span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.custo_base_triagem !== undefined && props.data?.custo_base_triagem !== null
                ? Number(props.data.custo_base_triagem).toLocaleString("pt-BR", { style: "currency", currency: "BRL" })
                : "---"}
            </span>
          </div>
        </div>

        <div className="w-full grid grid-cols-2 gap-2 gap-y-6 mt-4">
          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">Transportadora</span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.razao_social
                ? props.data.razao_social
                : "---"}
            </span>
          </div>

          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">Data Modificação</span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.data_historico ? formatDateTimeBR(props.data.data_historico) : "---"}
            </span>
          </div>

          <div className="flex flex-col w-full">
            <span className="text-sm text-[#1E2121] font-semibold mb-1">Usuário</span>
            <span className="text-sm text-[#666666] font-normal">
              {props.data?.usuario ? props.data.usuario : "---"}
            </span>
          </div>
        </div>
      </div>
    </ModalSideBar>
  );
};

export default Info;
